import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { SxProps } from "@mui/system";

const borderRadius = { xs: 4, md: 6 };

export type PricingContainerProps = BoxProps & {
  customWidthHeight: SxProps;
};

export const PricingContainer: React.FC<PricingContainerProps> = (props) => {
  return (
    <Box
      data-component="PricingContainer"
      sx={{
        width: "100%",
        maxWidth: 414,
        border: (theme) => {
          return {
            xs: `4px solid ${theme.colors.greenLightest}`,
            md: `8px solid ${theme.colors.greenLightest}`,
          };
        },
        borderTop: (theme) => {
          return {
            md: `8px solid ${theme.colors.greenLightest}`,
          };
        },
        backgroundColor: (theme) => `${theme.colors.greenLightest}`,
        borderRadius,
        boxShadow: {
          xs: "none",
          md: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
        },
        ...props.sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius,
          ...props.customWidthHeight,
        }}
      >
        <Box style={{ paddingTop: 4 }}>{props.children}</Box>
      </Box>
    </Box>
  );
};
